<template>
  <div>
    <v-btn
      v-if="status === 'CAT'"
      depressed
      x-small
      class="white--text"
      color="#0097A7"
      @click="$emit('eventDetail')"
    >
      Waiting Cataloguing
    </v-btn>

    <v-btn
      v-if="status == 'DRAFT'"
      depressed
      x-small
      color="#CFD8DC"
      @click="$emit('eventDetail')"
    >
      Draft
    </v-btn>

    <v-btn
      v-if="status == 'NI'"
      depressed
      x-small
      class="white--text"
      color="#FF7043"
      @click="$emit('eventDetail')"
    >
      Need Info Requester
    </v-btn>

    <v-btn
      v-if="status == 'APP1'"
      depressed
      x-small
      class="white--text"
      color="#5C6BC0"
      @click="$emit('eventDetail')"
    >
      Waiting Approval
    </v-btn>

    <v-btn
      v-if="status == 'DRAFT_CAT'"
      depressed
      x-small
      class="white--text"
      color="#0288D1"
      @click="$emit('eventDetail')"
    >
      Waiting Sent to SAP
    </v-btn>

    <v-btn
      v-if="status == 'REG'"
      depressed
      x-small
      class="white--text"
      color="#66BB6A"
      @click="$emit('eventDetail')"
    >
      Registered on SAP
    </v-btn>

    <v-btn
      v-if="status == 'FAIL'"
      depressed
      x-small
      class="white--text"
      color="#FFA000"
      @click="$emit('eventDetail')"
    >
      Failed
    </v-btn>

    <v-btn
      v-if="status == 'RJT'"
      depressed
      x-small
      class="white--text"
      color="#EF5350"
      @click="$emit('eventDetail')"
    >
      Rejected
    </v-btn>

    <v-btn
      v-if="status == 'HIGH'"
      depressed
      x-small
      class="white--text"
      color="#EF5350"
    >
      High
    </v-btn>

    <v-btn
      v-if="status == 'MEDIUM'"
      depressed
      x-small
      class="white--text"
      color="#FFA000"
    >
      Medium
    </v-btn>

    <v-btn
      v-if="status == 'LOW'"
      depressed
      x-small
      class="white--text"
      color="#42A5F5"
    >
      Low
    </v-btn>

    <v-btn
      v-if="status == 'EXT'"
      depressed
      x-small
      class="white--text"
      color="#01579B"
    >
      Extend
    </v-btn>

    <v-btn
      v-if="status == 'NEW'"
      depressed
      x-small
      class="white--text"
      color="#43A047"
    >
      New
    </v-btn>

    <v-btn
      v-if="status == 'UPLOAD'"
      depressed
      x-small
      class="white--text"
      color="#E65100"
    >
      Upload
    </v-btn>

    <v-icon v-if="image_available === 'Y'" color="#EF6C00">mdi-image</v-icon>
  </div>
</template>

<script>
export default {
  props: {
    status: { type: String, required: true },
    image_available: { type: String, required: false },
  },
  data() {
    return {}
  },
}
</script>

<style>
/* .v-btn {
  font-size: 11px !important;
} */
</style>
